import fall from "../images/funciones/1-ico-caidas.svg";
import help from "../images/funciones/2-ico-ayuda.svg";
import health from "../images/funciones/3-ico-monitoreo.svg";
import phisics from "../images/funciones/4-ico-habitos.svg";
import mindfullness from "../images/funciones/5-ico-cognitivas.svg";

const services = {
    fallDetector: {
      title: "Detección de Caídas",
      image: { fall },
      sub: "Detectamos caídas dentro y fuera del hogar, y en caso de que sucedan, desde nuestro Ellie Center articulamos con el sistema de salud una rápida asistencia. ¡Tranquilo, desde Ellie Center vamos a quedarnos con vos hasta que llegue la ayuda!",
    },
    helpButton: {
      title: "Botón de Ayuda",
      image: { help },
      sub: "¿Te pasó algo? Podés activar el botón de ayuda y nos comunicaremos de inmediato con vos para ayudarte. Vas a poder también establecer una Red de Ayuda personalizada, con tus amigos, hijos, vecinos, o quién vos decidas para que también puedan ayudarte.",
    },
    healthSigns: {
      title: "Signos Vitales",
      image: { health },
      sub: "Monitoreamos constantemente tus signos vitales, como el Rítmo Cardíaco y la Temperatura. Ante cualquier variación que nos llame la atención, vamos a poder comunicarnos con vos y tu Red de Ayuda para asegurarnos que estés bien estés dónde estés.",
    },
    phisics: {
      title: "Actividad Física",
      image: { phisics },
      sub: "¡Cuerpo sano, mente sana! Te vamos a ayudar a ejercitarte y a saber que tan bien te está haciendo. Es importante mantener un buen ritmo de actividad física para tener músculos fuertes, articulaciones flexibles, y así evitar caídas y accidentes.",
    },
    mindfullness: {
      title: "Neuro Cognitiva",
      image: { mindfullness },
      sub: "Uno de los desafíos de la etapa +65 años, es mantener las funciones neurocognitivas. Vamos a ayudarte a saber como estás, y vamos a proponer ejercicios para mantener y hasta mejorar tu memoria, la rapidez mental, etc. ¡Y lo vamos a hacer con juegos!",
    },
  };

  export default services;